module.exports = __webpack_public_path__ + "img/profesor_1.da36accb.webp";